import { Component, Input, Inject, OnChanges } from 'angular-ts-decorators';
import { fetchGroupPrice } from '@gn-audio/core/api/pricing/fetch-group-price';
import { fetchFamilyPrice } from '@gn-audio/core/api/pricing/fetch-family-price';
import { fetchProductPrice } from '@gn-audio/core/api/pricing/fetch-product-price';
import { ISFCCGroupPrice, ISFCCFamilyPrice, ISFCCProductPrice, ISFCCPrice } from '@gn-audio/core/api/pricing/models';
import { ProductType } from '@gn-audio/core/common/enums/product-type.enum';

import template from './callout-message.component.html';

@Component({
  selector: 'calloutMessage',
  template,
})
export class CalloutMessageComponent implements OnChanges {
  public static $inject: ReadonlyArray<string> = [];

  @Input() public productId?: number;
  @Input('@') public productType?: ProductType;

  public price?: ISFCCPrice;

  constructor(@Inject('$q') private readonly $q: ng.IQService) { }

  public get canShow(): boolean {
    return !!this.price && !!this.message;
  }

  public get message(): string {
    const { calloutMsg, couponCalloutMessage, c_calloutMsg, c_couponCalloutMessage } = this.price as ISFCCFamilyPrice & ISFCCGroupPrice & ISFCCProductPrice
    return c_calloutMsg || calloutMsg || c_couponCalloutMessage || couponCalloutMessage;
  }

  public ngOnChanges() {
    if (!this.productId || !this.productType) {
      return;
    }

    const pricePromise: Promise<ISFCCPrice | undefined> = this.getPrice();
    if (!pricePromise) {
      return;
    }

    this.$q.when(pricePromise)
      .then((x: ISFCCPrice) => (this.price = x));
  }

  private async getPrice(): Promise<ISFCCPrice | undefined> {
    let promise: Promise<ISFCCPrice>;
    switch (this.productType) {
      case ProductType.Family:
        promise = fetchFamilyPrice(this.productId) as Promise<ISFCCFamilyPrice>;
        break;

      case ProductType.Group:
        promise = fetchGroupPrice(this.productId) as Promise<ISFCCGroupPrice>;
        break;

      case ProductType.Product:
        promise = fetchProductPrice(this.productId) as Promise<ISFCCProductPrice>;
        break;

      default:
        break;
    }

    return promise;
  }
}
